import React, { useState, useEffect } from 'react';
import {
    Box, TextField, Button, Grid, Typography, MenuItem, Paper, IconButton
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import dayjs from 'dayjs';

// Dummy API service (replace with real API)
import { getWeekOffs, addWeekOff, updateWeekOff, deleteWeekOff } from '../../../services/weekOffService'

const weekdays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const EmployeeWeekOffs = () => {
    const [weekOffs, setWeekOffs] = useState([]);
    const [form, setForm] = useState({
        id_week_off: 0,
        id_employee: '',
        week_off_day: '',
        effective_from: dayjs(),
        effective_to: null,
    });

    const loadData = async () => {
        const data = await getWeekOffs();
        setWeekOffs(data);
    };

    useEffect(() => {
        loadData();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {
            ...form,
            effective_from: form.effective_from?.format('YYYY-MM-DD'),
            effective_to: form.effective_to?.format('YYYY-MM-DD') || null,
        };

        if (form.id_week_off === 0) {
            await addWeekOff(payload);
        } else {
            await updateWeekOff(payload);
        }

        resetForm();
        loadData();
    };

    const resetForm = () => {
        setForm({
            id_week_off: 0,
            id_employee: '',
            week_off_day: '',
            effective_from: dayjs(),
            effective_to: null,
        });
    };

    const handleEdit = (row) => {
        setForm({
            ...row,
            effective_from: dayjs(row.effective_from),
            effective_to: row.effective_to ? dayjs(row.effective_to) : null,
        });
    };

    const handleDelete = async (id) => {
        await deleteWeekOff(id);
        loadData();
    };

    return (
        <Box p={3}>
            <Typography variant="h6" mb={2}>Employee Week Off Entry</Typography>
            <Paper sx={{ p: 2, mb: 3 }}>
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid item xs={2}>
                            <TextField
                                label="Employee ID"
                                type="number"
                                size='small'
                                fullWidth
                                value={form.id_employee}
                                onChange={(e) => setForm({ ...form, id_employee: e.target.value })}
                                required
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <TextField
                                select
                                label="Week Off Day"
                                size='small'
                                fullWidth
                                value={form.week_off_day}
                                onChange={(e) => setForm({ ...form, week_off_day: e.target.value })}
                                required
                            >
                                {weekdays.map((day) => (
                                    <MenuItem key={day} value={day}>{day}</MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={3}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="Effective From"
                                    size='small'
                                    value={form.effective_from}
                                    onChange={(newVal) => setForm({ ...form, effective_from: newVal })}
                                    format="YYYY-MM-DD"
                                    slotProps={{ textField: { fullWidth: true, size:'small'  } }}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={3}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label="Effective To (optional)"
                                    size='small'
                                    value={form.effective_to}
                                    onChange={(newVal) => setForm({ ...form, effective_to: newVal })}
                                    format="YYYY-MM-DD"
                                    slotProps={{ textField: { fullWidth: true, size:'small' } }}
                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid item xs={2}>
                            <Button type="submit" variant="contained" color="primary" fullWidth>
                                {form.id_week_off === 0 ? 'Add' : 'Update'}
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Paper>

            <Paper sx={{ p: 2 }}>
                <Typography variant="subtitle1" gutterBottom>Week Offs List</Typography>
                {weekOffs.map((row) => (
                    <Grid container spacing={1} key={row.id_week_off} alignItems="center" sx={{ mb: 1 }}>
                        <Grid item xs={1}>{row.id_employee}</Grid>
                        <Grid item xs={2}>{row.week_off_day}</Grid>
                        <Grid item xs={2}>{row.effective_from}</Grid>
                        <Grid item xs={2}>{row.effective_to || '-'}</Grid>
                        <Grid item xs={2}>
                            <IconButton onClick={() => handleEdit(row)}><EditIcon /></IconButton>
                            <IconButton onClick={() => handleDelete(row.id_week_off)}><DeleteIcon color="error" /></IconButton>
                        </Grid>
                    </Grid>
                ))}
            </Paper>
        </Box>
    );
};

export default EmployeeWeekOffs;
